import { Placement } from 'bloko/common/metrics';

export interface BoundingClientRect {
    top: number;
    right: number;
    bottom: number;
    left: number;
    width: number;
    height: number;
}

export type Direction = Placement.Top | Placement.Bottom | Placement.Left | Placement.Right;

export type Directions = Direction[];

export type ValueOf<T> = T[keyof T];

export type TypeElementMetrics = HTMLElement | SVGGraphicsElement;
